import { Box } from "@chakra-ui/react";
import React from "react";

export const ManagerLogoPlaceholder = () => (
  <Box minH={{ base: "35px", md: "55px" }}></Box>
);
